import React from "react";
import { useAppContext } from "../../context/appContext";

const sizeSort = (a, b, lists) => {
  const sizeList = lists?.listSkylightSizes.map((size) => size.text);
  const aRank = sizeList?.indexOf(a.size || a.diameter);
  const bRank = sizeList?.indexOf(b.size || b.diameter);
  return aRank - bRank;
};

const selectInput = (e, input) => {
  e.preventDefault();
  input?.select();
};

const PriceBox = ({ index, priceName, value, previousValue, inputPackage }) => {
  const { handleInput, enableEdits, showPrevious, priceTable, handleKeyDown } = inputPackage;
  const inputID = `${priceTable}-${priceName}-${index}`;
  const inputPrice = document?.getElementById(inputID);
  // console.log("previousValue:", previousValue)
  return (
    <td>
      <div className="price-field">
        <input
          id={inputID}
          className="three-fourths"
          value={value || "-"}
          name={`${priceName}`}
          onChange={(e) => handleInput(e, index, priceTable)}
          onFocus={(e) => selectInput(e, inputPrice)}
          disabled={!enableEdits}
          onKeyDown={handleKeyDown}
        />
        {showPrevious && <span className="previous-price">{previousValue}</span>}
      </div>
    </td>
  );
};

const SkylightPrices = ({ title, priceTable, pricePackage }) => {
  const { prices, lists } = useAppContext();

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, showPrevious, handleKeyDown } =
    pricePackage;
  const inputPackage = {
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
    priceTable,
  };

  return (
    <div>
      <h4>{title}</h4>
      <table>
        <tbody>
          <tr>
            <th>Size</th>
            <th>Domes Only</th>
            <th>Mill Frame</th>
            <th>Bronze Frame</th>
            <th>Self Flashing Mill</th>
            <th>Self Flashing Bronze</th>
            <th>Velux FCM Clear</th>
            <th>Velux FCM White</th>
            <th>Velux FS Clear</th>
            <th>Velux Flashing Kit</th>
            <th>Reflash</th>
          </tr>
          {prices[priceTable] &&
            prices[priceTable]
              .filter((price) => price.price_sheets_id === parseInt(priceSheet))
              .sort((a, b) => sizeSort(a, b, lists))
              .map((listedPrice, index) => {
                // console.log("prices[priceTable]:", prices[priceTable].filter((price) => price.price_sheets_id === parseInt(formerPriceSheet)))
                const previousPrice = prices[priceTable]
                  .filter((price) => price.price_sheets_id === parseInt(formerPriceSheet))
                  .sort((a, b) => sizeSort(a, b, lists))[index];

                // console.log("previousPrice", previousPrice)
                return (
                  <tr key={listedPrice.id}>
                    <td width="6;0">{listedPrice.size}</td>
                    <PriceBox
                      index={index}
                      priceName="domes_only"
                      value={listedPrice.domes_only}
                      previousValue={previousPrice?.domes_only}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="with_mill"
                      value={listedPrice.with_mill}
                      previousValue={previousPrice?.with_mill}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="with_bronze"
                      value={listedPrice.with_bronze}
                      previousValue={previousPrice?.with_bronze}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="sf_mill"
                      value={listedPrice.sf_mill}
                      previousValue={previousPrice?.sf_mill}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="sf_bronze"
                      value={listedPrice.sf_bronze}
                      previousValue={previousPrice?.sf_bronze}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="velux_clear"
                      value={listedPrice.velux_clear}
                      previousValue={previousPrice?.velux_clear}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="velux_white"
                      value={listedPrice.velux_white}
                      previousValue={previousPrice?.velux_white}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="sf_velux"
                      value={listedPrice.sf_velux}
                      previousValue={previousPrice?.sf_velux}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="velux_flashing"
                      value={listedPrice.velux_flashing}
                      previousValue={previousPrice?.velux_flashing}
                      inputPackage={inputPackage}
                    />
                    <PriceBox
                      index={index}
                      priceName="reflash"
                      value={listedPrice.reflash}
                      previousValue={previousPrice?.reflash}
                      inputPackage={inputPackage}
                    />
                  </tr>
                );
              })}
        </tbody>
      </table>
    </div>
  );
};

const SunTunnelPrices = ({ type, priceTable, pricePackage }) => {
  const { prices, lists } = useAppContext();

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, showPrevious, handleKeyDown } =
    pricePackage;
  const inputPackage = {
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
    priceTable,
  };

  return (
    <div className="">
      <h4>{type} Sun Tunnel Prices</h4>
      <table>
        <tbody>
          <tr>
            <th>Diameter</th>
            <th>New Install</th>
          </tr>
          {prices[priceTable]
            .filter((price) => price.price_sheets_id === parseInt(priceSheet))
            .sort((a, b) => sizeSort(a, b, lists))
            .map((listedPrice, index) => {
              const previousPrice = prices[priceTable]
                .filter((price) => price.price_sheets_id === parseInt(formerPriceSheet))
                .sort((a, b) => sizeSort(a, b, lists))[index];

              return (
                <tr key={listedPrice.id}>
                  <td width="120">{listedPrice.diameter}</td>

                  <PriceBox
                    index={index}
                    priceName="tunnel"
                    value={listedPrice.tunnel}
                    previousValue={previousPrice?.tunnel}
                    inputPackage={inputPackage}
                  />
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

const LineItems = ({ pricePackage }) => {
  const { prices, lists } = useAppContext();
  const priceTable = "extrasPrices";

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, showPrevious, handleKeyDown } =
    pricePackage;
  const inputPackage = {
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
    priceTable,
  };

  return (
    <div className="">
      <h4>Line Items</h4>
      <table>
        <tbody>
          <tr>
            <th>Item</th>
            <th>Price</th>
          </tr>
          {prices[priceTable]
            .filter((price) => price.price_sheets_id === parseInt(priceSheet))
            .sort((a, b) => {
              const sizeList = lists.listExtras?.map((item) => item.id);
              const aRank = sizeList.indexOf(a.extras_id);
              const bRank = sizeList.indexOf(b.extras_id);
              return aRank - bRank;
            })
            .map((listedPrice, index) => {
              const previousPrice = prices[priceTable]
                .filter((price) => price.price_sheets_id === parseInt(formerPriceSheet))
                .sort((a, b) => sizeSort(a, b, lists))[index];

              return (
                <tr key={listedPrice.id}>
                  <td>{listedPrice.item}</td>
                  <PriceBox
                    index={index}
                    priceName="price"
                    value={listedPrice.price}
                    previousValue={previousPrice?.price}
                    inputPackage={inputPackage}
                  />
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};


const Vents = ({ pricePackage }) => {
  const { prices, lists } = useAppContext();
  const priceTable = "ventPrices";

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, showPrevious, handleKeyDown } =
    pricePackage;
  const inputPackage = {
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
  };

  return (
    <div className="">
      <h4>Attic Vents</h4>
      <table>
        <tbody>
          <tr>
            <th>Item</th>
            <th>Price</th>
          </tr>
          {prices[priceTable]
            .filter((price) => price.price_sheets_id === parseInt(priceSheet))
            .sort((a, b) => {
              const sizeList = lists.listExtras?.map((item) => item.id);
              const aRank = sizeList.indexOf(a.extras_id);
              const bRank = sizeList.indexOf(b.extras_id);
              return aRank - bRank;
            })
            .map((listedPrice, index) => {
              const previousPrice = prices[priceTable]
                .filter((price) => price.price_sheets_id === parseInt(formerPriceSheet))
                .sort((a, b) => sizeSort(a, b, lists))[index];

              return (
                <tr key={listedPrice.id}>
                  <td>{listedPrice.item}</td>
                  <PriceBox
                    index={index}
                    priceName="price"
                    value={listedPrice.price}
                    previousValue={previousPrice?.price}
                    inputPackage={inputPackage}
                  />
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

const Labor = ({ pricePackage }) => {
  const { prices } = useAppContext();
  const priceTable = "laborPrices";

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, showPrevious, handleKeyDown } =
    pricePackage;

  const inputPackage = {
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
    priceTable,
  };

  const laborTable = prices[priceTable].filter(
    (price) => price.price_sheets_id === parseInt(priceSheet)
  )[0];

  const previousTable = prices[priceTable].filter(
    (price) => price.price_sheets_id === parseInt(formerPriceSheet)
  )[0];

  console.log("priceSheet:", priceSheet)
  console.log("priceTable:", priceTable)
  console.log("prices[priceTable]:", prices[priceTable])
  console.log("laborTable:", laborTable)
  
  return (
    <div className="">
      <h4>Labor</h4>
      <table>
        <tbody>
          <tr>
            <th>Item</th>
            <th>Price</th>
          </tr>

          <tr key="manHours">
            <td>Hourly Labor</td>
            <PriceBox
              index={0}
              priceName="labor_hourly"
              value={laborTable?.labor_hourly}
              previousValue={previousTable?.labor_hourly}
              inputPackage={inputPackage}
            />
          </tr>
          <tr key="serviceCall">
            <td>Service Call</td>
            <PriceBox
              index={0}
              priceName="service_call"
              value={laborTable?.service_call}
              previousValue={previousTable?.service_call}
              inputPackage={inputPackage}
            />
          </tr>
          <tr key="laborCost">
            <td>Labor Cost</td>
            <PriceBox
              index={0}
              priceName="labor_cost"
              value={laborTable?.labor_cost}
              previousValue={previousTable?.labor_cost}
              inputPackage={inputPackage}
            />
          </tr>
        </tbody>
      </table>
    </div>
  );
};

const Commissions = ({ pricePackage }) => {
  const { prices } = useAppContext();
  const priceTable = "commissions";

  if(!prices) return null

  const { priceSheet, formerPriceSheet, handleInput, enableEdits, showPrevious, handleKeyDown } =
    pricePackage;

  const inputPackage = {
    handleInput,
    enableEdits,
    showPrevious,
    handleKeyDown,
    priceTable,
  };
  const commissionTable = prices[priceTable].filter(
    (price) => price.price_sheets_id === parseInt(priceSheet)
  )[0];

  const previousTable = prices[priceTable].filter(
    (price) => price.price_sheets_id === parseInt(formerPriceSheet)
  )[0];

  console.log("priceSheet:", priceSheet)
  console.log("priceTable:", priceTable)
  console.log("prices[priceTable]:", prices[priceTable])
  console.log("commissionTable:", commissionTable)

  return (
    <div className="">
      <h4>Commissions</h4>
      <table>
        <tbody>
          <tr>
            <th>Item</th>
            <th>Price</th>
          </tr>

          <tr key="stdSales">
            <td>Standard Sales %</td>
            <PriceBox
              index={0}
              priceName="standard_sales"
              value={commissionTable?.standard_sales}
              previousValue={previousTable?.standard_sales}
              inputPackage={inputPackage}
            />
          </tr>
          <tr key="stdService">
            <td>Standard Service %</td>
            <PriceBox
              index={0}
              priceName="standard_service"
              value={commissionTable?.standard_service}
              previousValue={previousTable?.standard_service}
              inputPackage={inputPackage}
            />
          </tr>
          <tr key="comSales">
            <td>Commercial Sales %</td>
            <PriceBox
              index={0}
              priceName="commercial_sales"
              value={commissionTable?.commercial_sales}
              previousValue={previousTable?.commercial_sales}
              inputPackage={inputPackage}
            />
          </tr>
          <tr key="comService">
            <td>Commercial Service %</td>
            <PriceBox
              index={0}
              priceName="commercial_service"
              value={commissionTable?.commercial_service}
              previousValue={previousTable?.commercial_service}
              inputPackage={inputPackage}
            />
          </tr>
          <tr key="comMatt">
            <td>Matt&apos;s Commercial %</td>
            <PriceBox
              index={0}
              priceName="commercial_matt"
              value={commissionTable?.commercial_matt}
              previousValue={previousTable?.commercial_matt}
              inputPackage={inputPackage}
            />
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export { PriceBox, SkylightPrices, SunTunnelPrices, LineItems, Vents, Labor, Commissions };
